package ru.villawonka.app.domain.usecase

import ru.villawonka.app.common.utils.Either
import ru.villawonka.app.domain.model.*
import ru.villawonka.app.domain.repository.UserRepository

class GetUserCountryUseCase(private val userRepository: UserRepository) {

    suspend operator fun invoke(): Either<NetworkFailure, UserCountryDomain> =
        userRepository.getCountry()
}